import { ApiError } from "../types/graphql";
import { GraphQLFormattedError } from "graphql/index";

const messagesFromApiError = (error: ApiError): string[] => {
  if (error.messages?.length) {
    return error.messages;
  }

  if (error.fullMessages?.length) {
    return error.fullMessages;
  }

  return [];
};

export class EasyError extends Error {
  constructor(
    public apiErrors: ReadonlyArray<ApiError>,
    public gqlErrors: ReadonlyArray<GraphQLFormattedError>
  ) {
    super(
      gqlErrors
        .map(e => e.message)
        .concat(apiErrors.flatMap(messagesFromApiError))
        .filter(Boolean)
        .join("\n")
    );
  }
}
